import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        title: {
            paddingLeft: theme.spacing(2),
        },
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            position: 'static',
        },
        tableContent: {
            boxShadow: 'none !important',
        },
        paginationWrapper: {
            marginTop: theme.spacing(1),
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'right',
        },
    }
})

export default useStyles
